import { useAuth } from "@/lib/config/auth-provider";

/**
 * Assistant Platform v1 (docs/plans/assistant-platform-v1-execution-plan.md).
 *
 * Server-enforced gating (`FeatureFlag.ASSISTANT_PLATFORM` +
 * `assertAssistantPlatformEnabled` on every new controller) lands at Step 8.1;
 * this is the frontend read of the same flag key (`user.featureFlags.<key>`).
 * Both `HomeLabStage` (what renders) and `useHomeLabSubmit` (what the submit
 * guard allows) call this hook independently rather than threading a boolean
 * between them, so the two cannot drift: each reads the same underlying
 * context value fresh.
 */
export function useAssistantPlatformEnabled(): boolean {
  const { user } = useAuth();
  return user?.featureFlags?.assistantPlatform === true;
}
